import {Component, OnInit} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {ApiService} from '../../services/api.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {TemplateService} from "../../services/template.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import * as moment from 'moment';
import {CALENDAR_LOCALE} from "../../services/constant";
import * as _ from 'lodash';
import {el} from "@angular/platform-browser/testing/src/browser_util";
@Component({
  selector: 'app-resolve-error',
  templateUrl: './resolve-error.component.html',
  styleUrls: ['./resolve-error.component.scss'],
  providers:[TemplateService]
})
export class ResolveErrorComponent implements OnInit {

  loading = false;
  errors = [];
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  modalData: any;
  modal: NgbModalRef;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  calendarLocale = CALENDAR_LOCALE.TH;
  rdDocumentType: any;
  selectedRdDocumentType: any;
  documentType:any;
  sortBy = null;
  sortMode = null;
  selectedCustomercode =null;
  customercode:any;
  documentNumber :any;
  delivery_address:any;
  commonAddress:any;
  selsetecdCommon:any;
  CountAddress=null;
  id_error:any;
  disable= false;
  alerterror :any;
  loading_main = false;
  checkdate = null;
  defaultLabel = null;
  // console: any;

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private template: TemplateService,
    private translate: TranslateService
  ) {
    this.currentPage = 1;
    this.itemsPerPage = 40;
    this.totalItems = 0;

  }

  ngOnInit() {
    this.rdDocumentType = this.template.getDropdown();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
    this.loadErrors();
    this.loadTexts();
  }
loadTexts(){
    this.defaultLabel = this.translate.instant('COMMON.ALL');
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.defaultLabel = this.translate.instant('COMMON.ALL');
    this.selectedCustomercode = null;
    this.customercode = null;
    this.selectedRdDocumentType = null;
    this.customercode = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getErrors().subscribe(
      (result) => {
        _.forEach(result.results, (obj) => {
          this.customercode.push({
            label: obj.customer_code,
            value: obj.customer_code
          })
        });
        this.customercode = _.uniqBy(this.customercode, 'label');
      },
      error => error(status)
    );


    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();
  }

  loadErrors(page?) {
    this.errors = [];
    this.loading = true;
    this.customercode;
    let keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
    let keependDate = moment(this.endDate).format('YYYY-MM-DD');
    let params = new HttpParams();
    // const currentPage = this.currentPage.toString();
    // const page_size = this.itemsPerPage.toString();
     if (this.selectedCustomercode && this.selectedRdDocumentType ) {
      params = params.append('customer_code', this.selectedCustomercode);
      params = params.append('document_type', this.selectedRdDocumentType);}
    if(this.selectedCustomercode) {params = params.append('customer_code', this.selectedCustomercode);}
    if(this.selectedRdDocumentType) {params = params.append('document_type', this.selectedRdDocumentType);}
    if(this.documentNumber) {params = params.append('document_number', this.documentNumber);}
    if(this.selectedCustomercode == null&&this.selectedRdDocumentType == null && this.documentNumber == null)
      if(this.checkdate == 1 ){
    params = params.append('document_date_gte', keepstartDate);
    params = params.append('document_date_lte', keependDate);
    }
    {params = params.append('page',this.currentPage.toString())
    params = params.append('page_size', this.itemsPerPage.toString())
    }

    this.apiService.getErrors(params).subscribe(
      (data) => {
      this.totalItems = data.count;

      this.errors = data.results;
      this.loading = false;
    }
      );

  }
   sentdate(){
    this.checkdate = 1 ;
  }

  optionChanged() {
     this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.loadErrors();
    //
  }

  pageChanged() {
    //
    this.loadErrors(this.currentPage);
  }

  resolveError($event: MouseEvent, popup: any, rowData: any) {
    if (rowData.reason === 'certificate is not found') {
      const data = {
        error_id: rowData.id
      };
      this.apiService.postResendJson(data).subscribe(
        res => {
          this.loadErrors();
        },
        error => {
          console.error(error.error.message);
        },
      );

      return;
    }
    this.modalData = rowData;
    this.disable = false;
    this.modal = this.modalService.open(popup, {backdrop: 'static', keyboard: false});
    this.id_error = rowData.id;
    this.delivery_address=rowData.delivery_address;
    this.commonAddress = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];
    _.forEach(rowData.common_address, (obj) => {
      this.CountAddress = obj;
      console.log(this.CountAddress)
          this.commonAddress.push({
            label: obj,
            value: obj
          })
    });

  }
  changeAdd(){
        this.delivery_address = this.selsetecdCommon;
    if(this.selsetecdCommon==null){
      this.disable = false;
    }else {
      this.disable = true
    }

  }

  revertBack(){
    this.CountAddress = null;
    this.delivery_address = null;
    this.CountAddress = null;
    this.selsetecdCommon = null;
    this.alerterror = null;
    this.modal.close();
  }
  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (2020) + ':' + (thisYear);
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }
    search() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.loadErrors();
  }
  clearSearch(){
    this.customercode = null;
    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.selectedRdDocumentType = null;
    this.customercode = null;
     this.startDate = null;
    this.endDate = new Date();
    this.startDate = new Date();
    this.sortBy = null;
    this.sortMode = null;
    this.totalItems  =null;
    this.selsetecdCommon = null;
    this.disable = false;
    this.CountAddress = null;
    this.documentNumber= null;
    this.checkdate = null;
    this.loadErrors();
    this.loadTexts();
  }
  save_new_customer(){
    this.loading = true;
    this.loading_main = true;
    // let params = new HttpParams();
    //  params = params.append('error_id', this.id_error);
    if(this.selsetecdCommon==null){
      this.delivery_address = this.modalData.delivery_address
    }else{
      this.delivery_address;
    }
    const data = {
      'delivery_address': this.delivery_address,
      'error_id':this.id_error
    };
    this.apiService.postErrors(data).subscribe(
          res=>{

          },
      error => {
        this.alerterror = error;
      console.log('alertooo',this.alerterror.error)
        },
    );
    setTimeout(() => {
      this.loading_main = false;
      this.loading = false;
      if(!this.alerterror){
        this.modal.close()
      }
      this.clearSearch();
      this.ngOnInit()

    },
      2000);
  }

  checkErrorCode(): string {
    if (this.alerterror && this.alerterror.error) {
      if (this.alerterror.error.includes('Customer code')) {
        return 'RESOLVE.CUSTOMER-NOT-MATCH';
      } else if (this.alerterror.error.includes('Delivery address')) {
        return 'RESOLVE.NOT-MATCH';
      } else if (this.alerterror.error.includes('java.lang')) {
        return 'RESOLVE.SIGNING-ERROR';
      }
    }
    return '';
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/resolve-error/resolve-error.component.ts